import React from 'react';

const HeartIcon = ({ size = 36, onClick, stroke = '#7A7A7A', fill = '' }) => {
    return (
        <div
            className="icon-wishlist"
            style={{ fontSize: size }}
            onClick={onClick} // Add onClick handler
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
            >
                <path
                    d="M11.5643 3.4877L12 4.26143L12.4357 3.4877C12.9372 2.59697 13.6697 1.85103 14.5598 1.32604C15.4459 0.803451 16.4567 0.518484 17.4909 0.50018C19.1506 0.574814 20.7116 1.29009 21.8354 2.48816C22.9622 3.68942 23.5581 5.2784 23.4955 6.90771L23.4952 6.9173V6.92689C23.4952 8.45932 22.8621 10.0944 21.8521 11.7179C20.8456 13.3358 19.4906 14.9011 18.1076 16.2836C15.3428 19.0476 12.5168 21.0314 12.2923 21.1877C12.2922 21.1877 12.2922 21.1877 12.2921 21.1878L12 21.3909L11.709 21.1886C11.7088 21.1884 11.7086 21.1882 11.7083 21.1881C11.4781 21.0268 8.65474 19.0441 5.89234 16.2828C4.50942 14.9005 3.15437 13.3354 2.14785 11.7176C1.13794 10.0943 0.504839 8.45931 0.504839 6.92689V6.9173L0.504471 6.90771C0.441923 5.2784 1.0378 3.68942 2.16458 2.48816C3.28836 1.29009 4.84941 0.574814 6.50905 0.50018C7.54328 0.518485 8.55407 0.803451 9.44017 1.32604C10.3303 1.85103 11.0628 2.59697 11.5643 3.4877Z"
                    stroke={stroke}
                    fill={fill}
                />
            </svg>
        </div>
    );
};

export default HeartIcon;
